import { cancelAllRequests, cancelRequestsByUrlPattern, cancelQueryRequests } from './mutator/axios';
import { queryClient } from '../plugins/vue-query';

/**
 * Global API for canceling requests.
 *
 * This combines both the Vue Query cancellation and Axios cancellation
 * mechanisms to ensure all requests are properly canceled.
 */
export const RequestCancellation = {
  /**
   * Cancel all pending requests (both Axios and Vue Query)
   * @param message The cancellation message (for logging/debugging)
   */
  cancelAll: (message = 'Canceled by user') => {
    // Cancel all Axios requests
    cancelAllRequests(message);

    // Cancel all Vue Query queries
    queryClient.cancelQueries();
  },

  /**
   * Cancel only query requests (GET), let mutations continue
   * @param message The cancellation message (for logging/debugging)
   */
  cancelQueries: (message = 'Queries canceled') => {
    // Cancel only GET requests in Axios
    cancelQueryRequests(message);

    // Cancel all Vue Query queries
    queryClient.cancelQueries();
  },

  /**
   * Cancel requests that match a specific URL pattern
   * @param urlPattern String or RegExp to match URLs against
   * @param message The cancellation message (for logging/debugging)
   */
  cancelByUrlPattern: (urlPattern: string | RegExp, message = 'Canceled by pattern match') => {
    cancelRequestsByUrlPattern(urlPattern, message);

    // For Vue Query, we can't easily filter by URL, so we don't cancel those
    // You'd need to use queryKey-based cancellation for Vue Query
  },

  /**
   * Cancel queries by query key
   * @param queryKey The query key to match
   */
  cancelByQueryKey: (queryKey: any[]) => {
    queryClient.cancelQueries({ queryKey });
  },

  /**
   * Cancels requests when navigating away from a page or component
   * Call this in the onBeforeRouteLeave or onBeforeRouteUpdate navigation guards
   */
  cancelOnNavigation: () => {
    RequestCancellation.cancelAll('Navigation interrupted request');
  }
};

export default RequestCancellation;
